import React from "react";
import { Layout } from "antd";
import "./SuperAdminContainer.css";

const { Content } = Layout;

const SuperAdminContainer = ({ children }) => {
  return (
    <Layout className="superadmin-container">
      <Content className="superadmin-content">{children}</Content>
    </Layout>
  );
};

export default SuperAdminContainer;
